import { render, staticRenderFns } from "./ProfilePanel.vue?vue&type=template&id=33143c86&scoped=true"
import script from "./ProfilePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfilePanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfilePanel.vue?vue&type=style&index=0&id=33143c86&prod&lang=scss&scoped=true"
import style1 from "./ProfilePanel.vue?vue&type=style&index=1&id=33143c86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33143c86",
  null
  
)

export default component.exports